export enum FilterGroups {
    Emotions = "Emotions",
    General = "General",
    Metrics = "Metrics",
    TagGroups = "Tag Groups",
    AgentGroups = "Agent Groups",
}

export const FilterGroupsOrder = {
    [FilterGroups.General]: 0,
    [FilterGroups.Emotions]: 1,
    [FilterGroups.Metrics]: 2,
    [FilterGroups.TagGroups]: 3,
    [FilterGroups.AgentGroups]: 4,
};
